import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class DynamicActionsAPI extends ComponentAPI {
    /**
     * Returns the current set of actions being rendered.
     */
    getActions() {
        return this.state.actions;
    }
    /**
     * Updates the current set of actions being rendered.
     *
     * @param actions - The new set of actions to be rendered.
     */
    setActions(actions) {
        this.setState({ actions });
    }
    /**
     * Returns the extra data available to the component.
     */
    getData() {
        return this.state.data ?? {};
    }
    /**
     * Returns the current type of actions being rendered.
     */
    getType() {
        return this.state.type;
    }
    /**
     * Updates the current actions type.
     *
     * @param type - Thew new actions type.
     */
    setType(type) {
        this.setState({ type });
    }
}
export { DynamicActionsAPI, };
//# sourceMappingURL=dynamic-actions-api.js.map